import { useDispatch, useSelector } from "react-redux";
import { uiSlice } from "../slices/uiSlice.jsx";

export const useModal = () => {
  let dispatch = useDispatch();
  let ui = useSelector((state) => state.ui);
  return {
    checkModal: (name) => {
      return ui.modals[name];
    },
    openModal: (name, data = {}) => {
      return dispatch(uiSlice.actions.openModal({ name, data }));
    },
    closeModal: (name) => {
      return dispatch(uiSlice.actions.closeModal({ name }));
    },
  };
};
